import { ADICIONAR_DADOS_PAGAMENTO } from '../types'

export default function adicionarDadosComprador (dadosPagamento) {
  return {
    type: ADICIONAR_DADOS_PAGAMENTO,
    payload: dadosPagamento
  }
}
